import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Login = [
    {
        path: '/resultpayment',
        name: 'Resultpayment',
        component: () => import('../../views/result/Resultpayment.vue')
    },
    {
        path: '/wxMiddlePage',
        name: 'WxMiddlePage',
        component: () => import('../../views/result/wxMiddlePage.vue')
    },
    {
        path: '/zfbMiddlePage',
        name: 'ZfbMiddlePage',
        component: () => import('../../views/result/zfbMiddlePage.vue')
    },
    {
        path: '/text',
        name: 'Text',
        component: () => import('../../views/text.vue')
    },
]

export default Login
